import React from "react";
import { ShieldCheckIcon } from "@heroicons/react/24/outline";
import SettingsSection from "../fields/SettingsSection";
import SettingsField from "../fields/SettingsField";
import RadioGroup from "../fields/RadioGroup";

export default function PrivacySection({ form, onChange }) {
  return (
    <SettingsSection
      id="privacy-safety"
      title="Privacy & Safety"
      icon={<ShieldCheckIcon className="h-5 w-5 text-primary" />}
    >
      <SettingsField
        label="Default note visibility"
        htmlFor="defaultVisibility"
        description="Applies to new notes. You can override per note in the composer."
      >
        <RadioGroup
          name="defaultVisibility"
          value={form.defaultVisibility}
          onChange={(v) => onChange("defaultVisibility", v)}
          options={[
            { value: "public", label: "Public" },
            { value: "private", label: "Private" },
          ]}
        />
      </SettingsField>
    </SettingsSection>
  );
}
